/**
 * @generated SignedSource<<2e1d2738e489f8cb021434e4b00598de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateEmailVerificationInput = {
  email: string;
};
export type useCreateEmailVerificationProfileMutation$variables = {
  input: CreateEmailVerificationInput;
};
export type useCreateEmailVerificationProfileMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateEmailVerificationProfileMutation = {
  response: useCreateEmailVerificationProfileMutation$data;
  variables: useCreateEmailVerificationProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateEmailVerificationProfileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateEmailVerificationPayload",
        "kind": "LinkedField",
        "name": "createEmailVerification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateEmailVerificationProfileMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "CreateEmailVerificationPayload",
        "kind": "LinkedField",
        "name": "createEmailVerification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b4e14d727c83a0bfaca86b18d372427",
    "id": null,
    "metadata": {},
    "name": "useCreateEmailVerificationProfileMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateEmailVerificationProfileMutation(\n  $input: CreateEmailVerificationInput!\n) {\n  responsePayload: createEmailVerification(input: $input) {\n    success\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d6a297a574588eeead066a668ed9dd1";

export default node;
